/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
import numeral from 'numeral';

import { EditButton, SVGButton, DeleteButton } from 'components/widgets/buttons';
import { XeroChargeLink, XeroLegacyChargeLink, XeroReturnLink, GoogleDriveLink, InvoiceLink } from 'components/widgets/icons/link-icons';
import AgreementMismatch from 'components/models/agreement/agreement-mismatch';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

import ApproveExpenseBill from './approve-expense-bill';


export function ExpenseBillRow({ expenseBill, edit, createReturn, disableActions, purchaseOrder, currentUser, deleteExpenseBill, isReturn }) {
  const cutoff = moment('04/01/2020', 'MM/DD/YYYY');
  const legacy = moment(expenseBill.createdAt).isBefore(cutoff);

  return (
    <tr>
      <td rowSpan={expenseBill.lineItems.length + 4}>
        {!expenseBill.approved &&
          <ApproveExpenseBill purchaseOrder={purchaseOrder} expenseBill={expenseBill} currentUser={currentUser} />
        }
        {expenseBill.approved &&
          <SVG src="svg/check.svg" className="expense-bill-approved" />
        }
      </td>
      <td colSpan="3" className="emphasize">
        {moment(expenseBill.date).format('M/D')}
      </td>
      <td>
        <div className="d-flex">
          <GoogleDriveLink title="View Receipt in Google Drive" fileId={expenseBill.receipt.fileId} className="margin-right" />
          {Person.isLead(currentUser) && expenseBill.xeroId &&
            <div className="d-flex">
              {legacy && <XeroLegacyChargeLink xeroId={expenseBill.xeroId} className="margin-right" />}
              {!legacy && !isReturn && <XeroChargeLink xeroId={expenseBill.xeroId} className="margin-right" />}
              {!legacy && isReturn && <XeroReturnLink xeroId={expenseBill.xeroId} className="margin-right" />}
            </div>
          }
          {Person.isLead(currentUser) && expenseBill.invoice &&
            <InvoiceLink invoiceId={expenseBill.invoice} />
          }
        </div>
      </td>
      <td className="expense-bill-actions">
        <AgreementMismatch className="inline-block" item={expenseBill} />
        <Tooltip title={expenseBill.invoice ? 'Can\'t delete a charge after it\'s been invoiced' : ''} className="inline-block">
          <DeleteButton
            onClick={() => deleteExpenseBill(expenseBill.id, purchaseOrder.id)}
            disabled={disableActions || expenseBill.invoice}
          />
        </Tooltip>
        {!expenseBill.returnFor &&
          <Tooltip title="Return items" className="inline-block">
            <SVGButton src="svg/return.svg" className="return-button" onClick={createReturn} disabled={disableActions} />
          </Tooltip>
        }
        <Tooltip title={expenseBill.invoice ? `Can\'t edit a ${expenseBill.returnFor ? 'return' : 'charge'} after it\'s been invoiced` : ''} className="inline-block">
          <EditButton onClick={edit} className="edit-expense-bill" disabled={expenseBill.invoice || disableActions} />
        </Tooltip>
      </td>
    </tr>
  );
}

export function LineItemRow({ item, isReturn }) {
  return (
    <tr className="line-item-row">
      <td className="right-align deemphasize">
        {item.quantity}
      </td>
      <td className="right-align deemphasize">
        {numeral(isReturn ? item.unitCost * -1 : item.unitCost).format('$0,0.00')}
      </td>
      <td className="right-align">
        {numeral(isReturn ? item.quantity * item.unitCost * -1 : item.quantity * item.unitCost).format('$0,0.00')}
      </td>
      <td colSpan="2">
        {item.purchaseOrderLineItem.description}
      </td>
    </tr>
  );
}

export function ShippingTaxTotalRow({ amount, description, isReturn }) {
  const emphasis = _.startsWith(description, 'Total') ? 'emphasize' : 'deemphasize';

  return (
    <tr className="shipping-tax-total-row line-item-row">
      <td />
      <td />
      <td className={classNames(['right-align', emphasis])}>
        {numeral(isReturn ? amount * -1 : amount).format('$0,0.00')}
      </td>
      <td className={classNames({ deemphasize: !_.startsWith(description, 'Total') })} colSpan="2">
        {description}
      </td>
    </tr>
  );
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/expense-bill-components.js